import LogoWithText from "../LogoWithText";

const AuthLogo = () => (
  <div className="flex items-center justify-center mb-8">
    <div className="w-64">
      <LogoWithText />
    </div>
  </div>
);

export default AuthLogo;
